<template>
  <div class="idle-hero-content">
    <Loading />
    <!-- <div>
        <div id="message-sticker"  @click="trigger">
                <div class="message-inner flex-center">
                    <div class="message-content">   
                        Just double checking you’re on the guest list!     
                    </div>
                </div>
        </div>
        </div> -->
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue"
export default {
  methods: {
    trigger() {
      window.open(
        "http://chat.bleachlondon.com/?utm_source=VIP-party&utm_medium=splash-page&utm_term=validation",
        "_blank"
      )
    }
  },

  components: {
    Loading
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$white: #fff;
$purple: #6e3dcb;
$pink: #edd4df;

$break-large: 720px;
$break-mid: 840px;

@mixin prefix($property, $value, $prefixes: ()) {
  @each $prefix in $prefixes {
    #{'-' + $prefix + '-' + $property}: $value;
  }
  #{$property}: $value;
}

@mixin linear-gradient($direction, $color-stops...) {
  background: nth(nth($color-stops, 1), 1);
  background: -moz-linear-gradient($direction, $color-stops);
  background: -webkit-linear-gradient($direction, $color-stops);
  background: -ms-linear-gradient($direction, $color-stops);
  background: linear-gradient($direction, $color-stops);
}

//FLEX
.flex-center {
  @include prefix(display, flex, webkit ms);
  @include prefix(align-items, center, webkit ms);
  @include prefix(justify-content, center, webkit ms);
}

.idle-hero-content {
  background: url("/assets/bg_green.jpg");
  background-size: cover;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: $white;
}
.idle-hero-content {
  position: relative;

  #message-sticker {
    position: absolute;
    top: 5%;
    right: 5%;
    width: 220px;
    height: 220px;
    z-index: 1;
    font-family: "Poppins", sans-serif;
    color: $white;

    @include prefix(box-shadow, 4px 12px 14px -4px rgba(0, 0, 0, 0.15));
    @include linear-gradient(15deg, $purple 0%, $pink 60%);
    @include prefix(border-radius, 50%);
    border: 4px solid $white;
    @media screen and (max-width: $break-large) {
      top: -2%;
      right: 0%;
    }
    .message-inner {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      .message-content {
        @include prefix(transform, rotate(15deg), webkit ms);
        padding: 10%;
        text-transform: uppercase;
        line-height: 1.3;
      }
    }
  }
}
</style>
